import actionTypes from '../../utilities/actionTypes';

// Action Definition

export interface IFetchAssetSuccess {
  type: actionTypes.FETCH_ASSETS_SUCCESS;
  payload: any;
}
export interface IFetchAssets {
  type: actionTypes.FETCH_ASSETS;
  resetFilters?: boolean;
}

export interface IFetchAssetPending {
  type: actionTypes.FETCH_ASSETS_PENDING;
}

export interface IUpdateAssets {
  type: actionTypes.UPDATE_ASSET;
  payload: any;
}

export interface IToggleSelectedAssets {
  type: actionTypes.TOGGLE_SELECTED_ASSETS;
  assets: string[];
}

export interface IFlushSelectedAssets {
  type: actionTypes.FLUSH_ASSETS;
}

export interface IEscalateAssets {
  type: actionTypes.ESCALATE_ASSETS;
  payload: any;
}

export interface ISnoozeAssets {
  type: actionTypes.SNOOZE_ASSETS;
  payload: any;
}

export interface IResolveAsset {
  type: actionTypes.RESOLVE_ASSET;
  payload: any;
}

export interface IResetFetchCount {
  type: actionTypes.RESET_FETCH_COUNT;
}
export interface IFetchAssetsRejected {
  type: actionTypes.FETCH_ASSETS_REJECTED;
}

export interface IDummyAction {
  type: actionTypes.DUMMY_ACTION;
  error: any;
}

export const fetchAssetsPending = (): IFetchAssetPending => {
  return { type: actionTypes.FETCH_ASSETS_PENDING };
};

export const fetchAssetsSuccess = (payload: any): IFetchAssetSuccess => {
  return {
    type: actionTypes.FETCH_ASSETS_SUCCESS,
    payload
  };
};

export const fetchAssets = (resetFilters?: boolean): IFetchAssets => {
  return {
    type: actionTypes.FETCH_ASSETS,
    resetFilters
  };
};

export const updateAssets = (payload: any): IUpdateAssets => {
  return {
    type: actionTypes.UPDATE_ASSET,
    payload
  };
};

export const escalate = (payload: any): IEscalateAssets => {
  return {
    type: actionTypes.ESCALATE_ASSETS,
    payload
  };
};

export const flushSelectedAssets = (): IFlushSelectedAssets => {
  return {
    type: actionTypes.FLUSH_ASSETS
  };
};

export const snoozeAssets = (payload: any): ISnoozeAssets => {
  return {
    type: actionTypes.SNOOZE_ASSETS,
    payload
  };
};

export const resolveAsset = (payload: any): IResolveAsset => {
  return {
    type: actionTypes.RESOLVE_ASSET,
    payload
  };
};

export const toggleSelectedAssets = (
  assets: string[]
): IToggleSelectedAssets => {
  return {
    type: actionTypes.TOGGLE_SELECTED_ASSETS,
    assets
  };
};
export const resetFetchCount = (): IResetFetchCount => {
  return {
    type: actionTypes.RESET_FETCH_COUNT
  };
};
export const fetchAssetRejected = (): IFetchAssetsRejected => {
  return {
    type: actionTypes.FETCH_ASSETS_REJECTED
  };
};
export const dummyAction = (error: any): IDummyAction => {
  return {
    type: actionTypes.DUMMY_ACTION,
    error
  };
};

export type IAssetActions =
  | IFetchAssetSuccess
  | IFetchAssetPending
  | IUpdateAssets
  | IFetchAssets
  | IFlushSelectedAssets
  | IToggleSelectedAssets
  | IEscalateAssets
  | ISnoozeAssets
  | IResolveAsset
  | IResetFetchCount
  | IFetchAssetsRejected
  | IDummyAction;
